import { FC } from 'react';
import logo from '../../assets/images/logo01.png';
import logoTate from '../../assets/images/logo01_tate.png';
import { isMobile } from '../../utils/DeviceType';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  style: React.CSSProperties;
};
const AppLogo: FC<Props> = ({ ...rest }) => {
  return (
    <div {...rest}>
      <img src={isMobile() ? logo : logoTate} alt="logo" />
    </div>
  );
};
export default AppLogo;
